/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPriceDto
 */
export interface GetPriceDto {
    /**
     * 
     * @type {string}
     * @memberof GetPriceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPriceDto
     */
    consultationType?: GetPriceDtoConsultationTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetPriceDto
     */
    supportingExaminationDictId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPriceDto
     */
    pricingGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPriceDto
     */
    articleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPriceDto
     */
    price: string;
}


/**
 * @export
 */
export const GetPriceDtoConsultationTypeEnum = {
    Neurological: 'Neurological',
    Ophthalmologist: 'Ophthalmologist',
    ENT: 'ENT',
    Psychiatric: 'Psychiatric'
} as const;
export type GetPriceDtoConsultationTypeEnum = typeof GetPriceDtoConsultationTypeEnum[keyof typeof GetPriceDtoConsultationTypeEnum];


/**
 * Check if a given object implements the GetPriceDto interface.
 */
export function instanceOfGetPriceDto(value: object): value is GetPriceDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function GetPriceDtoFromJSON(json: any): GetPriceDto {
    return GetPriceDtoFromJSONTyped(json, false);
}

export function GetPriceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPriceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'consultationType': json['consultationType'] == null ? undefined : json['consultationType'],
        'supportingExaminationDictId': json['supportingExaminationDictId'] == null ? undefined : json['supportingExaminationDictId'],
        'pricingGroupId': json['pricingGroupId'] == null ? undefined : json['pricingGroupId'],
        'articleId': json['articleId'] == null ? undefined : json['articleId'],
        'price': json['price'],
    };
}

export function GetPriceDtoToJSON(value?: GetPriceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'consultationType': value['consultationType'],
        'supportingExaminationDictId': value['supportingExaminationDictId'],
        'pricingGroupId': value['pricingGroupId'],
        'articleId': value['articleId'],
        'price': value['price'],
    };
}

